// extracted by mini-css-extract-plugin
export default {"cls1":"AgilysysLogo_cls1__tT9wj","cls2":"AgilysysLogo_cls2__XCd5Y"};